import { useMemo, useState, useEffect, useContext, useRef } from 'react';
import Calendar from './Components/Calendar.jsx';
import { Paper, Popover } from '@mui/material';
import CustomizerContext from '../../_helper/Customizer/index.jsx';


const PackageRateCalendar = ({ packageRatesData, calendarData, setCalendarData, tableHeaders, setTableHeaders, pagination, setPagination, paginationTotalRows, onEditClick, loader }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { mix_background_layout } = useContext(CustomizerContext)



    const columns = useMemo(
        () => [
            ...tableHeaders.map(header => (
                header.accessorKey === 'categories' ?
                    {
                        accessorKey: header.accessorKey,
                        header: header.header,
                        size: 150,
                        Header: header?.["Header"],
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                    }
                    :
                    {
                        accessorKey: header.accessorKey,
                        header: header.header,
                        size: 80,
                        Header: header?.["Header"]
                    }
            )),
        ],
        [tableHeaders],
    );

    console.log("tableHeaders", tableHeaders)

    return (
        <Paper sx={{ padding: "10px", backgroundColor: mix_background_layout == "dark-only" ? "#262932" : "#ffffff" }} >

            <Calendar
                calendarData={calendarData}
                calendarColumns={columns}
                isLoading={isLoading}
                loader={loader}
                pagination={pagination}
                setPagination={setPagination}
                paginationTotalRows={paginationTotalRows}
                mix_background_layout={mix_background_layout}
            />
        </Paper>
    )

}

export default PackageRateCalendar;
